import axios from 'axios'

const STORAGE_KEY = 'setup_progress_map'

export const allStepIds = ['email', 'telematics', 'import-trucks', 'drivers', 'create_load', 'assign_driver', 'assign_truck', 'send_email_to_broker'] as const

export type StepId = (typeof allStepIds)[number]

export type StepProgressMap = Partial<Record<StepId, boolean>>

export const getStepProgress = (): StepProgressMap => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY)
        return stored ? JSON.parse(stored) : {}
    } catch {
        return {}
    }
}

export const getSetUpProgress = (): boolean => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY)
        if (!stored) return false
        const progress: StepProgressMap = JSON.parse(stored)
        return allStepIds.every((stepId) => progress[stepId] === true)
    } catch {
        return false
    }
}
export const markStepCompleted = async (stepId: StepId, projectName: string | undefined): Promise<void> => {
    const progress = getStepProgress()
    if (!progress[stepId]) {
        progress[stepId] = true
        localStorage.setItem(STORAGE_KEY, JSON.stringify(progress))

        // Only make the API call if all steps are now completed
        if (getSetUpProgress() && projectName) {
            try {
                await axios.put(`/updater/settings/${projectName}`, {
                    isSetupCompleted: true,
                })
            } catch (error) {
                console.error('Failed to update setup completion status:', error)
                // Revert the step completion if the API call fails
                progress[stepId] = false
                localStorage.setItem(STORAGE_KEY, JSON.stringify(progress))
                throw error
            }
        }
    }
}

export const setStepStatus = (stepId: StepId, status: boolean): void => {
    const progress = getStepProgress()
    progress[stepId] = status
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress))
}

export const isStepCompleted = (stepId: StepId): boolean => {
    const progress = getStepProgress()
    return progress[stepId] === true
}

export const clearStepProgress = (): void => {
    localStorage.removeItem(STORAGE_KEY)
}
